import React, { useState } from 'react'
import { useTranslation } from 'react-i18next';
import { countryPhoneCodes } from 'utils/constants';
import Swal from 'sweetalert2'

import FormValidation from './FormValidation';

function RegistrationForm({ index, formValues, handleFormInput, isRegistrationFormValid }) {

  const { t } = useTranslation()

  // remove duplicate codes
  const newCountryPhoneCodes = countryPhoneCodes.filter((value, index, self) =>
    index === self.findIndex((t) => (
      t.code === value.code
    ))
  )

  // open chart size
  const openChartSize = () => {
    Swal.fire({
      imageUrl: "https://storage.googleapis.com/testing_storage_cloudxier/cloudxier-images/a49081a998d4b3e688453656d5a6305338aee9f8d250e7160a5ddaa28df933b7776783c5d7a8c28820d3f61f39be3dd1318fdf184337dc4e7a5e6c4a802fd89ae0ec821e1d303451b479d5ad9f63a31f8da564d7f77f0a020cb04dbc2e6d7606e2c1163a3ba584fd99ea81cc508a372ddfe6022cd29be2d9a5c5/rez-file-1746156521384.jpg",
      imageAlt: "polo-shirt-chart-size",
      showConfirmButton: false,
      showCloseButton: false,
    });
  }

  return (
    <div className='grid grid-cols-1 sm:grid-cols-6 gap-x-8 gap-y-4'>
      <div class="sm:col-span-3">
        <label class="block text-sm font-medium leading-6 text-gray-900">{t('contactFormLabel1')} *</label>
        <div class="mt-1">
          <input onChange={handleFormInput} value={formValues[`customer-name-${index}`]} placeholder={t('contactFormPlaceholder1')} type="text" name={`customer-name-${index}`} class="block w-full rounded-md border-0 p-2 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6" />
          <FormValidation value={formValues[`customer-name-${index}`]} showError={!isRegistrationFormValid} />
        </div>
      </div>
      <div class="sm:col-span-3">
        <label class="block text-sm font-medium leading-6 text-gray-900">{t('contactFormLabel42')} *</label>
        <div class="mt-1">
          <select onChange={handleFormInput} value={formValues[`gender-${index}`]} name={`gender-${index}`} class={`block w-full rounded-md bg-white border-0 p-2 shadow-sm ring-1 ring-inset ring-gray-300 ${formValues[`gender-${index}`] === "" ? "text-gray-400" : "text-gray-900"} focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6`}>
            <option value="">{t('contactFormPlaceholder42')}</option>
            <option value="Male">{t('contactFormOption421')}</option>
            <option value="Female">{t('contactFormOption422')}</option>
          </select>
          <FormValidation value={formValues[`gender-${index}`]} showError={!isRegistrationFormValid} />
        </div>
      </div>
      <div class="sm:col-span-3">
        <label class="block text-sm font-medium leading-6 text-gray-900">{t('contactFormLabel2')} *</label>
        <div class="mt-1">
          <input onChange={handleFormInput} value={formValues[`customer-email-${index}`]} placeholder={t('contactFormPlaceholder2')} type="text" name={`customer-email-${index}`} class="block w-full rounded-md border-0 p-2 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6" />
          <FormValidation value={formValues[`customer-email-${index}`]} showError={!isRegistrationFormValid} />
        </div>
      </div>
      <div class="sm:col-span-3">
        <label class="block text-sm font-medium leading-6 text-gray-900">{t('contactFormLabel7')} *</label>
        <div class="bg-white flex rounded-md border-0 p-2 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6 w-full mt-1 p-2">
          {/* <select onChange={handleFormInput} value={formValues[`customer-phcode-${index}`]} name={`customer-phcode-${index}`} className='w-fit px-2 font-bold text-sm select-none outline-none'>
            <option value='' selected></option>
            {newCountryPhoneCodes.sort((a, b) => a.code - b.code).map(((country) => (
              <option value={country.code}>{country.code}</option>
            )))}
          </select> */}
          <span>+</span>(<input type='number' onChange={handleFormInput} value={formValues[`customer-phcode-${index}`]} name={`customer-phcode-${index}`} className='w-8 font-bold text-sm select-none outline-none text-center' /><span>)</span>
          <input onChange={handleFormInput} value={formValues[`phone-number-${index}`]} name={`phone-number-${index}`} placeholder={t('contactFormPlaceholder7')} type="number" min="0" class="outline-none w-full block pl-2 border-0 text-gray-900 placeholder:text-gray-400 sm:text-sm sm:leading-6" />
        </div>
        <FormValidation value={formValues[`phone-number-${index}`] && formValues[`customer-phcode-${index}`]} showError={!isRegistrationFormValid} />
      </div>
      <div class="sm:col-span-3">
        <label class="block text-sm font-medium leading-6 text-gray-900">{t('contactFormLabel3')} *</label>
        <div class="mt-1">
          <input onChange={handleFormInput} value={formValues[`company-name-${index}`]} placeholder={t('contactFormPlaceholder3')} type="text" name={`company-name-${index}`} class="block w-full rounded-md border-0 p-2 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6" />
          <FormValidation value={formValues[`company-name-${index}`]} showError={!isRegistrationFormValid} />
        </div>
      </div>
      {/* <div class="sm:col-span-3">
        <label class="block text-sm font-medium leading-6 text-gray-900">{t('contactFormLabel4')} *</label>
        <div class="mt-1">
          <input onChange={handleFormInput} value={formValues[`customer-division-${index}`]} placeholder={t('contactFormPlaceholder4')} type="text" name={`customer-division-${index}`} class="block w-full rounded-md border-0 p-2 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6" />
          <FormValidation value={formValues[`customer-division-${index}`]} showError={!isRegistrationFormValid} />
        </div>
        <label class="block text-sm font-medium leading-6 text-gray-900">{t('contactFormLabel41')} *</label>
        <div class="mt-1">
          <select onChange={handleFormInput} value={formValues[`t-shirt-size-${index}`]} name={`t-shirt-size-${index}`} class={`block w-full rounded-md bg-white border-0 p-2 shadow-sm ring-1 ring-inset ring-gray-300 ${formValues[`t-shirt-size-${index}`] === "" ? "text-gray-400" : "text-gray-900"} focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6`}>
            <option value="">{t('contactFormPlaceholder41')}</option>
            <option value="2XL">2XL</option>
            <option value="XL">XL</option>
            <option value="L">L </option>
            <option value="M">M</option>
            <option value="S">S</option>
            <option value="XS">XS</option>
          </select>
          <FormValidation value={formValues[`t-shirt-size-${index}`]} showError={!isRegistrationFormValid} />
        </div>
        <label class="block text-xs italic font-medium leading-6 text-gray-900">
          ** {t('contactFormDescription41')} &nbsp;
          <span onClick={openChartSize} className='text-xs italic underline font-bold leading-6 text-gray-900 cursor-pointer'>
            {t('viewChartSize')}.
          </span>
        </label>
      </div> */}
      <div class="sm:col-span-3">
        <label class="block text-sm font-medium leading-6 text-gray-900">{t('contactFormLabel6')}</label>
        <div class="mt-1">
          <input onChange={handleFormInput} value={formValues[`id-number-${index}`]} placeholder={t('contactFormPlaceholder6')} type="number" name={`id-number-${index}`} class="block w-full rounded-md border-0 p-2 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6" />
        </div>
      </div>
      <div class="sm:col-span-3">
        <label class="block text-sm font-medium leading-6 text-gray-900">{t('contactFormLabel8')}</label>
        <div class="mt-1">
          <input onChange={handleFormInput} value={formValues[`referral-code-${index}`]} placeholder={t('contactFormPlaceholder8')} type="text" name={`referral-code-${index}`} class="block w-full rounded-md border-0 p-2 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6" />
        </div>
      </div>
      <div class="sm:col-span-3">
        <label class="block text-sm font-medium leading-6 text-gray-900">{t('contactFormLabel9')}</label>
        <div class="mt-1">
          <textarea rows={5} onChange={handleFormInput} value={formValues[`notes-${index}`]} placeholder={t('contactFormPlaceholder9')} type="text" name={`notes-${index}`} class="block w-full rounded-md border-0 p-2 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6" />
        </div>
      </div>
    </div>
  )

}

export default RegistrationForm